<template>
  <d-container fluid class="px-4 main-content-container">
    <!-- Page Header -->
    <d-row no-gutters class="py-4 page-header">
      <div class="mb-0 text-center col-12 text-sm-left">
        <span class="text-uppercase page-subtitle d-block">Lista</span>
        <h3 class="page-title d-inline">Banners</h3>
        <router-link class="btn btn-success text-white float-right" :to="{ name: 'admin-banner-new' }">Novo banner</router-link>
      </div>
    </d-row>

    <!-- Default Light Table -->
    <d-row>
      <d-col>
        <d-card class="mb-4 card-small">
          <div class="card-header border-bottom d-flex justify-content-around">
            <d-col cols="12" md="5">
              <h6 class="m-0">Filtros para listagem</h6>
            </d-col>
            <d-col cols="12" md="7">
            </d-col>
          </div>
          <div class="p-0 pb-3 text-left card-body">
            <div class="table-overflow">
              <banner-table :banners="banners.list" />
            </div>
            <pagination :total-items="banners.total_items" :pagination.sync="pagination"></pagination>
          </div>
        </d-card>
      </d-col>
    </d-row>
  </d-container>
</template>

<script>
import { mapActions } from 'vuex';
import Events from '_utils/events';
import Pagination from '_shared/Pagination.vue';
import BannerTable from '../components/BannerTable.vue';

export default {
  name: 'banner-list',
  components: {
    Pagination,
    BannerTable,
  },
  data() {
    return {
      pagination: {
        skip: (this.$route.params.page - 1) * 10,
        take: 10,
        page: parseInt(this.$route.params.page, Number),
      },
    };
  },
  computed: {
    banners() {
      const { bannerList } = this.$store.state.banner;
      if (bannerList && bannerList.list.length) {
        return bannerList;
      }
      return {
        list: [],
        total_items: 0,
      };
    },
  },
  methods: {
    ...mapActions([
      'setToggle',
      'getBannerList',
    ]),
    getList() {
      this.getBannerList(this.pagination);
    },
  },
  mounted() {
    Events.$emit('sidebarVisible', false);
    this._onPagination = pagination => {
      if (pagination !== this.pagination.page) {
        this.$router.push({ params: { page: pagination } });
      }
      this.getList();
    };
    Events.$on('update:pagination', this._onPagination);
    this.getList();
  },
  beforeDestroy() {
    Events.$off('update:pagination', this._onPagination);
  },
};
</script>

<style lang="scss" scoped>
</style>
